import { __, isPreviewableMedia } from '../../utils';
import type { FeedMedia } from '../FeedItem/FeedItem';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Stack } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  media?: FeedMedia[];
};

/**
 * Prílohy podnetu, ktoré sa nedajú ukázať v galérii - PDF a iné dokumenty.
 *
 * [[ReportPhotos]] berie len obrázky a videá, takže bez tohto zoznamu by PDF,
 * ktoré občan k podnetu priložil, v detaile nebolo vidieť vôbec. Odkaz má
 * ten istý tvar ako príloha vyjadrenia úradu v [[ReportStatements]] - ikona
 * a meno súboru, otvorí sa v novej karte (nginx médií podá PDF inline).
 */
const ReportDocuments: React.FC<Props> = ({ media }) => {
  const documents = (media ?? []).filter(
    (item) => !isPreviewableMedia(item.type),
  );

  if (!documents.length) return null;

  return (
    <Stack
      component='ul'
      aria-label={__('Dokumenty')}
      sx={{
        gap: 0.75,
        alignItems: 'flex-start',
        m: 0,
        p: 0,
        listStyle: 'none',
      }}
    >
      {documents.map((item) => (
        <Box component='li' key={item.url} sx={{ maxWidth: 1 }}>
          <Box
            component='a'
            href={item.url}
            target='_blank'
            rel='noopener noreferrer'
            sx={(theme) => ({
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              maxWidth: 1,
              fontSize: theme.typography.pxToRem(13),
              color: theme.palette.primary.dark,
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            })}
          >
            <DescriptionOutlinedIcon sx={{ fontSize: 16, flex: 'none' }} />
            <Box
              component='span'
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {item.filename || __('Dokument')}
            </Box>
          </Box>
        </Box>
      ))}
    </Stack>
  );
};

export default ReportDocuments;
